import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';
import translationFR from './locales/fr/translation.json';
import translationDE from './locales/de/translation.json';
import translationZH from './locales/zh/translation.json';
import translationJA from './locales/ja/translation.json';
import translationPT from './locales/pt/translation.json';
import translationIT from './locales/it/translation.json';

const resources = {
    en: { translation: translationEN },
    es: { translation: translationES },
    fr: { translation: translationFR },
    de: { translation: translationDE },
    zh: { translation: translationZH },
    ja: { translation: translationJA },
    pt: { translation: translationPT },
    it: { translation: translationIT }
};

const detectionOptions = {
    order: ['localStorage', 'navigator'], // Primero localStorage, luego navegador
    lookupLocalStorage: 'userLanguage', // Clave en localStorage
    caches: ['localStorage'], // Guardar en localStorage
};

i18n
    .use(LanguageDetector) // Detecta el idioma del navegador
    .use(initReactI18next) // Pasa i18n a react-i18next
    .init({
        resources,
        fallbackLng: 'en', // Idioma por defecto si no se detecta uno válido
        detection: detectionOptions,
        interpolation: {
            escapeValue: false // React ya protege contra XSS
        },
        react: {
            useSuspense: false // Evitar problemas de suspense en algunos casos
        }
    });

export default i18n;